export default __webpack_public_path__ + "static/media/user-pics-4.19128830.png";